import { CartLinesUpdateEvent } from '@shopify/events';

const unionText = (es, en) => window.UnionLanguage?.language === 'es' ? es : en;

function updatePurchaseOptions(form) {
  const orderLanguage = form.querySelector('[data-union-order-language]');
  if (orderLanguage) orderLanguage.value = window.UnionLanguage?.language === 'es' ? 'es' : 'en';
  const data = JSON.parse(form.querySelector('[data-union-variants]').textContent);
  const variant = data.variants.find(v => String(v.id) === form.elements.id.value);
  if (!variant) return;
  const plan = form.querySelector('[data-union-plan]');
  if (plan) {
    const previous = plan.value;
    plan.replaceChildren(...variant.plans.map(p => new Option(`${data.isMembership ? unionText('Cada mes', 'Every month') : (window.UnionLanguage?.translate(p.label) || p.label)} · ${p.price}`, p.id)));
    if (!data.requiresPlan) plan.add(new Option(`${unionText('Compra única', 'One-time purchase')} · ${variant.price}`, ''));
    if ([...plan.options].some(option => option.value === previous)) plan.value = previous;
    updateFrequencyNote(form);
  }
  const button = form.querySelector('[type=submit]');
  button.disabled = !variant.available || (data.requiresPlan && !variant.plans.length);
  button.textContent = button.disabled ? unionText('No disponible', 'Unavailable') : unionText('Agregar al carrito', 'Add to cart');
  form.querySelector('[data-union-buy-status]').textContent = '';
}

function updateFrequencyNote(form) {
  const note = form.querySelector('[data-union-frequency-note] [data-union-copy]');
  if (!note) return;
  const recurring = !!form.querySelector('[data-union-plan]')?.value;
  note.dataset.en = recurring ? 'Billed monthly. One selection per delivery. Manage your subscription from your account. Shipping and taxes calculated at checkout.' : 'One selection. One payment. No renewal. Shipping and taxes calculated at checkout.';
  note.dataset.es = recurring ? 'Cobro mensual. Una selección por entrega. Gestiona tu suscripción desde tu cuenta. Envío e impuestos calculados al finalizar la compra.' : 'Una selección. Un pago. Sin renovación. Envío e impuestos calculados al finalizar la compra.';
  note.textContent = unionText(note.dataset.es, note.dataset.en);
}

document.querySelectorAll('[data-union-shop-buy]').forEach(updatePurchaseOptions);
document.addEventListener('union:languagechange', () => document.querySelectorAll('[data-union-shop-buy]').forEach(updatePurchaseOptions));
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-union-shop-buy]').forEach(updatePurchaseOptions));
document.addEventListener('change', event => {
  if (!(event.target instanceof HTMLSelectElement)) return;
  const form = event.target.closest('[data-union-shop-buy]');
  if (!form) return;
  if (event.target.name === 'id') updatePurchaseOptions(form);
  else if (event.target.name === 'selling_plan') updateFrequencyNote(form);
});

document.addEventListener('submit', async event => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.matches('[data-union-shop-buy]')) return;
  event.preventDefault();
  if (form.dataset.busy) return;
  const button = form.querySelector('[type=submit]');
  if (button.disabled) return;
  const status = form.querySelector('[data-union-buy-status]');
  form.dataset.busy = 'true';
  button.disabled = true;
  button.textContent = unionText('Agregando…', 'Adding…');
  status.textContent = '';
  try {
    const body = new FormData(form);
    const data = JSON.parse(form.querySelector('[data-union-variants]').textContent);
    const sections = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(el => el.dataset.sectionId))];
    if (sections.length) body.set('sections', sections.slice(0, 5).join(','));
    body.set('sections_url', location.pathname);
    let endpoint = form.action + '.js';
    let request = {method: 'POST', headers: {Accept: 'application/json'}, body};
    if (data.isMembership) {
      body.set('quantity', '1');
      const existingResponse = await fetch(window.Shopify.routes.root + 'cart.js', {headers: {Accept: 'application/json'}});
      if (!existingResponse.ok) throw new Error(unionText('No se pudo revisar el carrito. Inténtalo de nuevo.', 'The cart could not be checked. Please try again.'));
      const existingCart = await existingResponse.json();
      const index = existingCart.items.findIndex(item => String(item.variant_id) === String(body.get('id')));
      if (index !== -1) {
        const properties = {...existingCart.items[index].properties};
        for (const [key, value] of body.entries()) {
          const property = key.match(/^properties\[(.+)\]$/);
          if (property) properties[property[1]] = value;
        }
        endpoint = window.Shopify.routes.root + 'cart/change.js';
        request = {method: 'POST', headers: {Accept: 'application/json', 'Content-Type': 'application/json'}, body: JSON.stringify({
          line: index + 1, quantity: 1, selling_plan: body.get('selling_plan') ? Number(body.get('selling_plan')) : null,
          properties, sections: body.get('sections'), sections_url: location.pathname
        })};
      }
    }
    const response = await fetch(endpoint, request);
    const result = await response.json();
    if (!response.ok || result.status) throw new Error(result.description || unionText('No se pudo agregar el producto.', 'The product could not be added.'));
    const cartResponse = await fetch(window.Shopify.routes.root + 'cart.js', {headers: {Accept: 'application/json'}});
    if (!cartResponse.ok) { status.textContent = unionText('Producto agregado. Abre el carrito para revisar tu pedido.', 'Product added. Open the cart to review your order.'); return; }
    const cart = await cartResponse.json();
    const promise = Promise.resolve({cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: {sections: result.sections, items: cart.items, itemCount: cart.item_count, source: 'product-form-component', sourceId: form.querySelector('[name=id]').id, didError: false}});
    form.dispatchEvent(new CartLinesUpdateEvent({action: 'add', context: 'product', lines: [{merchandiseId: String(body.get('id')), quantity: Number(body.get('quantity'))}], promise}));
    status.textContent = unionText('Agregado al carrito.', 'Added to cart.');
  } catch (error) { status.textContent = error.message || unionText('No se pudo agregar el producto.', 'The product could not be added.'); }
  finally { delete form.dataset.busy; button.disabled = false; button.textContent = unionText('Agregar al carrito', 'Add to cart'); }
});
